import { render, staticRenderFns } from "./LibrarySummary.vue?vue&type=template&id=0a375006&scoped=true&"
import script from "./LibrarySummary.vue?vue&type=script&lang=ts&"
export * from "./LibrarySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a375006",
  null
  
)

export default component.exports